import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const PageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const Hero = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    paddingY: '4px',
  },
})

const Greeting = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '32px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const GreetingSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const SectionTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: '700',
    color: 'quickpass.ink',
    marginBottom: '12px',
    letterSpacing: '-0.3px',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const BalanceCardRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

const BalanceText = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const BalanceLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

const BalanceAmount = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const QuickActionsGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '12px',
  },
})

const QuickActionCard = styled(Link, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '20px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.15)',
    border: '1.5px solid transparent',
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      transform: 'translateY(-2px)',
      boxShadow: '0 18px 38px -16px rgba(128, 84, 255, 0.32)',
    },
  },
})

const QuickActionIconWrap = styled('span', {
  base: {
    fontSize: '22px',
    lineHeight: '1',
    color: 'quickpass.primary',
  },
})

const QuickActionTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const QuickActionSubtitle = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.4',
  },
})

const ComingSoonGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: '12px',
  },
})

const ComingSoonCard = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '18px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    opacity: '0.75',
  },
})

const ComingSoonIconWrap = styled('span', {
  base: {
    fontSize: '20px',
    lineHeight: '1',
    color: 'quickpass.inkSoft',
  },
})

const ComingSoonTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const ComingSoonPill = styled('span', {
  base: {
    alignSelf: 'flex-start',
    paddingX: '8px',
    paddingY: '2px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: '#EFE9FF',
    color: '#5B3FCC',
  },
})

export {
  PageStack,
  Hero,
  Greeting,
  GreetingSubtitle,
  SectionTitle,
  QuietText,
  BalanceCardRow,
  BalanceText,
  BalanceLabel,
  BalanceAmount,
  QuickActionsGrid,
  QuickActionCard,
  QuickActionIconWrap,
  QuickActionTitle,
  QuickActionSubtitle,
  ComingSoonGrid,
  ComingSoonCard,
  ComingSoonIconWrap,
  ComingSoonTitle,
  ComingSoonPill,
}
